(function () {
  'use strict';

  var ENHANCED_ATTRIBUTE = 'data-batch-b-content-a11y';

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isVisuallyHidden(element) {
    var item = element.closest('li');
    return item && window.getComputedStyle(item).display === 'none';
  }

  function enhanceProductTabs(scope) {
    scope.querySelectorAll('product-tab').forEach(function (productTab) {
      var tabList = productTab.querySelector('.tabs.tabs-horizontal');
      var tabs = Array.from(productTab.querySelectorAll('.tab-title')).filter(function (tab) {
        return !isVisuallyHidden(tab);
      });

      if (tabList) tabList.setAttribute('role', 'tablist');

      tabs.forEach(function (tab, index) {
        var panelId = (tab.getAttribute('href') || '').replace(/^#/, '');
        var panel = panelId ? productTab.querySelector('#' + CSS.escape(panelId)) : null;
        var isSelected = tab.classList.contains('is-open');
        var tabId = tab.id || 'product-tab-' + panelId + '-' + index;

        tab.id = tabId;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', String(isSelected));
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        if (panel) {
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabId);
          if (window.matchMedia('(min-width: 551px)').matches) {
            panel.setAttribute('aria-hidden', String(!isSelected && !panel.classList.contains('is-active')));
          } else {
            panel.removeAttribute('aria-hidden');
          }
        }
      });

      if (tabs.length && !tabs.some(function (tab) { return tab.getAttribute('aria-selected') === 'true'; })) {
        tabs[0].setAttribute('tabindex', '0');
      }

      productTab.querySelectorAll('.toggleLink[data-collapsible]').forEach(function (toggle) {
        var contentId = (toggle.getAttribute('href') || '').replace(/^#/, '');
        var content = contentId ? productTab.querySelector('#' + CSS.escape(contentId)) : null;
        var isExpanded = toggle.classList.contains('is-open');

        toggle.setAttribute('role', 'button');
        toggle.setAttribute('aria-expanded', String(isExpanded));
        if (content) {
          toggle.setAttribute('aria-controls', content.id);
          content.setAttribute('aria-hidden', String(!isExpanded));
        }
      });

      productTab.setAttribute(ENHANCED_ATTRIBUTE, 'true');
    });
  }

  function enhanceFaqs(scope) {
    scope.querySelectorAll('faqs-item .card-header').forEach(function (header) {
      var content = header.nextElementSibling;
      var title = header.querySelector('.title');
      var isExpanded = !header.classList.contains('collapsed');

      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-expanded', String(isExpanded));

      if (title) {
        title.removeAttribute('role');
        title.removeAttribute('tabindex');
      }

      if (content) {
        if (!content.id) content.id = 'faq-answer-' + Math.random().toString(36).slice(2);
        header.setAttribute('aria-controls', content.id);
        content.setAttribute('aria-hidden', String(!isExpanded));
      }
    });
  }

  function mediaLabel(element, prefix) {
    var image = element.querySelector('img');
    var text = cleanText(image && image.getAttribute('alt'));
    return text ? prefix + ': ' + text : prefix;
  }

  function isRendered(element) {
    if (!element || !element.isConnected) return false;
    if (element.parentElement && element.parentElement.closest('[hidden], [aria-hidden="true"]')) return false;

    var current = element;
    while (current && current !== document.body) {
      var style = window.getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      current = current.parentElement;
    }

    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function syncMainMediaFocus(nav) {
    var mediaItems = Array.from(nav.querySelectorAll('.media[data-fancybox][href]'));
    if (!mediaItems.length) return;

    var usesSlider = nav.classList.contains('slick-initialized') || mediaItems.some(function (media) {
      return !!media.closest('.slick-slide');
    });
    var activeMedia = null;

    if (usesSlider) {
      activeMedia = mediaItems.find(function (media) {
        var slide = media.closest('.slick-slide');
        return slide &&
          slide.classList.contains('slick-current') &&
          slide.classList.contains('slick-active') &&
          !slide.classList.contains('slick-cloned') &&
          isRendered(media);
      });
      if (!activeMedia) {
        activeMedia = mediaItems.find(function (media) {
          var slide = media.closest('.slick-slide');
          return slide && slide.classList.contains('slick-active') && !slide.classList.contains('slick-cloned') && isRendered(media);
        });
      }
    }

    if (!activeMedia) {
      activeMedia = mediaItems.find(isRendered) || mediaItems[0];
    }

    mediaItems.forEach(function (media) {
      var isActive = !usesSlider ? isRendered(media) : media === activeMedia;
      media.setAttribute('role', 'button');
      media.setAttribute('tabindex', isActive ? '0' : '-1');
      media.setAttribute('aria-hidden', String(!isActive));
      media.setAttribute('aria-label', mediaLabel(media, 'View larger image'));
      media.setAttribute(ENHANCED_ATTRIBUTE, 'true');
    });
  }

  function enhanceProductMedia(scope) {
    scope.querySelectorAll('.productView-nav').forEach(function (nav) {
      syncMainMediaFocus(nav);
    });

    scope.querySelectorAll('.productView-thumbnail-wrapper').forEach(function (wrapper) {
      var thumbnails = Array.from(wrapper.querySelectorAll('.productView-thumbnail .productView-thumbnail-link'));
      var visibleThumbnails = thumbnails.filter(isRendered);
      var currentThumbnail = visibleThumbnails.find(function (thumbnail) {
        var item = thumbnail.closest('.productView-thumbnail');
        return !!(item && item.closest('.slick-current'));
      }) || visibleThumbnails[0];

      thumbnails.forEach(function (thumbnail) {
        var item = thumbnail.closest('.productView-thumbnail');
        var isVideo = !!(item && item.querySelector('.productView-thumbnail-icon .icon-video'));
        var isModel = !!(item && item.querySelector('.productView-thumbnail-icon .icon-3d-model'));
        var prefix = isVideo ? 'Play video' : (isModel ? 'View 3D model' : 'Show image');
        var isVisible = visibleThumbnails.indexOf(thumbnail) !== -1;
        var isCurrent = thumbnail === currentThumbnail;

        thumbnail.setAttribute('role', 'button');
        thumbnail.setAttribute('tabindex', isCurrent ? '0' : '-1');
        thumbnail.setAttribute('aria-hidden', String(!isVisible));
        thumbnail.setAttribute('aria-label', mediaLabel(thumbnail, prefix));
        if (isCurrent) {
          thumbnail.setAttribute('aria-current', 'true');
        } else {
          thumbnail.removeAttribute('aria-current');
        }
        thumbnail.setAttribute(ENHANCED_ATTRIBUTE, 'true');
      });
    });

    scope.querySelectorAll('.productView-videoPopup .videoPopup-btn').forEach(function (button) {
      if (!button.hasAttribute('aria-label')) button.setAttribute('aria-label', 'Play product video');
    });
  }

  function enhance(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    enhanceProductTabs(root);
    enhanceFaqs(root);
    enhanceProductMedia(root);
  }

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest && event.target.closest('product-tab .tab-title[role="tab"]');
    if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) !== -1) {
      var productTab = tab.closest('product-tab');
      var tabs = Array.from(productTab.querySelectorAll('.tab-title[role="tab"]')).filter(function (item) {
        return !isVisuallyHidden(item);
      });
      var index = tabs.indexOf(tab);
      var nextIndex = index;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      event.preventDefault();
      tabs[nextIndex].focus();
      tabs[nextIndex].click();
      window.setTimeout(function () { enhanceProductTabs(productTab); }, 0);
      return;
    }
    if (tab && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      tab.click();
      window.setTimeout(function () { enhanceProductTabs(tab.closest('product-tab')); }, 0);
      return;
    }

    var faq = event.target.closest && event.target.closest('faqs-item .card-header[role="button"]');
    var toggle = event.target.closest && event.target.closest('product-tab .toggleLink[role="button"]');
    var thumbnail = event.target.closest && event.target.closest('.productView-thumbnail-link[role="button"]');

    if (thumbnail && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(event.key) !== -1) {
      var wrapper = thumbnail.closest('.productView-thumbnail-wrapper');
      var thumbnails = Array.from(wrapper.querySelectorAll('.productView-thumbnail-link[role="button"]')).filter(isRendered);
      var thumbnailIndex = thumbnails.indexOf(thumbnail);
      var nextThumbnailIndex = thumbnailIndex;

      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextThumbnailIndex = (thumbnailIndex - 1 + thumbnails.length) % thumbnails.length;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextThumbnailIndex = (thumbnailIndex + 1) % thumbnails.length;
      if (event.key === 'Home') nextThumbnailIndex = 0;
      if (event.key === 'End') nextThumbnailIndex = thumbnails.length - 1;

      event.preventDefault();
      thumbnails[nextThumbnailIndex].focus();
      thumbnails[nextThumbnailIndex].click();
      window.setTimeout(function () { enhanceProductMedia(document); }, 0);
      return;
    }

    var media = event.target.closest && event.target.closest('[data-batch-b-content-a11y][role="button"]');
    var keyboardTarget = faq || toggle || media;
    if (keyboardTarget && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      keyboardTarget.click();
      window.setTimeout(function () { enhance(document); }, 0);
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('product-tab, faqs-item, .productView-images-wrapper, .productView-container, .productView')) {
      window.setTimeout(function () { enhance(document); }, 0);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('.productView-container, .productView')) {
      window.setTimeout(function () { enhance(document); }, 0);
    }
  });

  function start() {
    enhance(document);
    var observerTimer;
    var observer = new MutationObserver(function (mutations) {
      var hasRelevantChange = mutations.some(function (mutation) {
        if (mutation.type === 'attributes') {
          return mutation.target.closest && mutation.target.closest('.productView-nav, .productView-thumbnail-wrapper');
        }
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (
            node.matches('product-tab, faqs-item, .productView-images-wrapper, .productView-thumbnail') ||
            node.querySelector('product-tab, faqs-item, .productView-images-wrapper, .productView-thumbnail')
          );
        });
      });
      if (!hasRelevantChange || observerTimer) return;
      observerTimer = window.setTimeout(function () {
        observerTimer = null;
        enhance(document);
      }, 100);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { enhance(document); }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhance(event.target);
  });
})();
